import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { PaymentGateway } from "../../entry/server/app.ts";
import { appRepo } from "../../repo/app-repo.ts";
import { AppContext } from "../../context/app-context.tsx";
import { appService } from "../../services/app-service.ts";

export default function GatewaysList() {
  const [gateways, setGateways] = useState<PaymentGateway[]>([]);
  const [loading, setLoading] = useState(true);
  const { setMessage } = useContext(AppContext);

  useEffect(() => {
    const fetchGateways = async () => {
      setLoading(true);

      try {
        const response = await appRepo.getGateways(1);
        if (!response.status || !response.data) {
          setMessage({ type: "error", message: response.message || "دریافت لیست درگاه‌ها ناموفق بود." });
          setGateways([]);
          return;
        }

        setGateways(response.data);
      } catch {
        setMessage({ type: "error", message: "خطا در ارتباط با سرور. دوباره تلاش کنید." });
        setGateways([]);
      } finally {
        setLoading(false);
      }
    };

    void fetchGateways();
  }, [setMessage]);

  async function deleteGateway(id: number) {
    if (!window.confirm("آیا مطمئن هستید که می خواهید این درگاه را حذف کنید؟")) {
      return;
    }
    const response = await appService.deleteGateway(id);
    if (!response.status) {
      setMessage({ type: "error", message: response.message || "حذف درگاه با خطا مواجه شد." });
      return;
    }
    setMessage({ type: "success", message: "درگاه با موفقیت حذف شد." });
    setGateways(gateways.filter((gateway) => gateway.id !== id));
  }

  if (loading) {
    return (
      <section className="mt-4 space-y-4">
        <div className="flex items-center justify-end">
          <Link
            to="/admin/gateways/new"
            className="rounded-xl bg-indigo-500 px-4 py-2 text-sm font-medium text-white transition hover:bg-indigo-400"
          >
            ایجاد درگاه جدید
          </Link>
        </div>
        <div className="rounded-2xl border border-slate-800 bg-slate-900/60 p-6 text-slate-300">
          در حال دریافت لیست درگاه‌ها...
        </div>
      </section>
    );
  }

  if (!gateways.length) {
    return (
      <section className="mt-4 space-y-4">
        <div className="flex items-center justify-end">
          <Link
            to="/admin/gateways/new"
            className="rounded-xl bg-indigo-500 px-4 py-2 text-sm font-medium text-white transition hover:bg-indigo-400"
          >
            ایجاد درگاه جدید
          </Link>
        </div>
        <div className="rounded-2xl border border-slate-800 bg-slate-900/60 p-6 text-slate-300">
          هنوز هیچ درگاه پرداختی ثبت نشده است.
        </div>
      </section>
    );
  }

  return (
    <section className="mt-4 space-y-4">
      <div className="flex items-center justify-end">
        <Link
          to="/admin/gateways/new"
          className="rounded-xl bg-indigo-500 px-4 py-2 text-sm font-medium text-white transition hover:bg-indigo-400"
        >
          ایجاد درگاه جدید
        </Link>
      </div>

      <div className="overflow-x-auto rounded-2xl border border-slate-800 bg-slate-900/60">
        <table className="min-w-full divide-y divide-slate-800 text-sm">
          <thead className="bg-slate-900/80">
            <tr>
              <th className="px-4 py-3 text-right font-medium text-slate-300">شناسه</th>
              <th className="px-4 py-3 text-right font-medium text-slate-300">نام درگاه</th>
              <th className="px-4 py-3 text-right font-medium text-slate-300">اسلاگ</th>
              <th className="px-4 py-3 text-right font-medium text-slate-300">کلید</th>
              <th className="px-4 py-3 text-right font-medium text-slate-300">وضعیت</th>
              <th className="px-4 py-3 text-right font-medium text-slate-300">عملیات</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-800">
            {gateways.map((gateway) => (
              <tr key={gateway.id} className="transition hover:bg-slate-900">
                <td className="whitespace-nowrap px-4 py-3 text-slate-300">{gateway.id}</td>
                <td className="whitespace-nowrap px-4 py-3 text-slate-100">{gateway.name}</td>
                <td className="whitespace-nowrap px-4 py-3 text-slate-300">{gateway.slug}</td>
                <td className="whitespace-nowrap px-4 py-3 text-slate-300">{gateway.key || "-"}</td>
                <td className="px-4 py-3">
                  <span
                    className={`rounded-full px-3 py-1 text-xs font-medium ${
                      gateway.is_active
                        ? "bg-emerald-500/20 text-emerald-300"
                        : "bg-slate-700/60 text-slate-300"
                    }`}
                  >
                    {gateway.is_active ? "فعال" : "غیرفعال"}
                  </span>
                </td>
                <td className="px-4 py-3 flex items-center gap-2">
                  <Link
                    to={`/admin/gateways/${gateway.id}/edit`}
                    className="inline-flex rounded-lg border border-slate-700 px-3 py-1.5 text-xs text-slate-200 transition hover:border-indigo-400 hover:text-indigo-300"
                  >
                    ویرایش درگاه
                  </Link>
                  <button
                    onClick={() => deleteGateway(gateway.id)}
                    className="inline-flex rounded-lg border border-red-700 px-3 py-1.5 text-xs text-red-200 transition hover:border-red-400 hover:text-red-300"
                  >
                    حذف درگاه
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
}